var LocationModel = require("../models/LocationModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function LocationsWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.locations = ko.observableArray([]);
  self.name = 'LocationsWS';			// Convenience name for debugging


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/locations';
  });


	/**
	 * Finds a queue by the provided ID
	 *
	 * @method getLocationById
	 * @param {Number} iId
	 * @returns {LocationModel | Null}
	 */
  self.getLocationById = function (iId) {
    return self.locations().find(function (loc) {
      return loc.id == iId;
    });
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {LocationsWS}
	 */
  self.processData = function (xmlData) {
    var aTemp = [];

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Convert the XML to JSON
    var json = xmlToJson.parse(xmlData);

    // If the root node (merchantLocations) was found...
    if (json.merchantLocations) {
      // Grab an array of the merchantLocation nodes
      var locs = Array.makeArray(json.merchantLocations.merchantLocation);

      // Iterate over all found nodes and turn them into LocationModels
      locs.forEach(function (loc) {
        aTemp.push(new LocationModel(loc));
      });

      // Assign the collection of LocationModels to the locations observable
      self.locations(aTemp);

      // If there is only one location, set the selected location so the
      // user doesn't have to select one item from a list.
      if (aTemp.length === 1) {
        self.parent.selectedLocationIds([aTemp[0].id]);
      }
    }

    return self;
  };

  return self;
};

LocationsWS.prototype = AbstractWS.prototype;
LocationsWS.prototype.constructor = LocationsWS;

module.exports = LocationsWS
